import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { BehaviorSubject, Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RepairOrderService {
  private adasThirdPartyDataSubject$ = new BehaviorSubject<any>(null);
  public adasThirdPartyDataSubjectRo$: Subject<any>;

  public adasThirdPartyData$ = this.adasThirdPartyDataSubject$.asObservable();

  setAdasThirdPartyData(data: any) {
    console.log('Setting new value:', data);
    this.adasThirdPartyDataSubject$.next(data);
  }

  setAdasThirdPartyDataRo(data: any): void {
    console.log('Setting new value 2:', data);
    this.adasThirdPartyDataSubjectRo$.next(data);
  }

  get currentValue() {
    return this.adasThirdPartyDataSubject$.getValue();
  }

  constructor( private http: HttpClient,private apiUrl: ApiService,) {
    this.adasThirdPartyDataSubjectRo$ = new Subject<any>();
   }
// change work order status
changeStatusTicket(data) {
  return this.http.post<any>(this.apiUrl.apiChangeStatusTicket(), data);
}
  // get SupportTicketsList
  getSupportTicketsList(data) {
    return this.http.post<any>(this.apiUrl.apiGetSupportTicketsList(), data);
  }  
  
  // woo complete order
  wooCompleteSupportTicket(data) {
    return this.http.post<any>(this.apiUrl.apiWooCompleteSupportTicket(), data);
  }

  // complete order
  completeSupportTicket(data) {
    return this.http.post<any>(this.apiUrl.apiCompleteSupportTicket(), data);
  }
   // delete
   deleteSupportTicketsList(data) {
    return this.http.post<any>(this.apiUrl.apiDeleteSupportTicketsList(), data);
  }
  // get SupportTicketsList
  updateSupportTicketsList(data) {
    return this.http.post<any>(this.apiUrl.apiUpdateSupportTicketsList(), data);
  }
  // getWorkOrderList
  getWorkOrderList(data) {
    return this.http.post<any>(this.apiUrl.apiGetWorkOrderList(), data);
  }
  // getJOBDetailsList
  getJOBDetailsList(data) {
    return this.http.post<any>(this.apiUrl.apiGetJOBDetailsList(), data);
  }
  // getCompaniesList
  getCompaniesList(data) {
    return this.http.post<any>(this.apiUrl.apiGetCompaniesList(), data);
  }
  apiManageCompany(data) {
    return this.http.post<any>(this.apiUrl.apiManageCompany(), data);
  }
  // Manage Job Type
  managejobType(data) {
    return this.http.post<any>(this.apiUrl.apiManagejobType(), data);
  }
  // updateJOBDetailsList
  updateJOBDetailsList(data) {
    return this.http.post<any>(this.apiUrl.apiUpdateJOBDetailsList(), data);
  }
  // getRateCardList
  getRateCardList(data) {
    return this.http.post<any>(this.apiUrl.apiGetRateCardList(), data);
  }
  // updatRateCardList
  updatRateCardList(data) {
    return this.http.post<any>(this.apiUrl.apiUpdatRateCardList(), data);
  }
  // Approve Work Order
  approveWorkOrder(data) {
    return this.http.post<any>(this.apiUrl.apiApproveWorkOrder(), data);
  }

  updateEstimateApprove(data) {
    return this.http.post<any>(this.apiUrl.apiUpdateEstimateApprove(), data);
  }

  manageAdasThirdParty(data) {
    return this.http.post<any>(this.apiUrl.manageAdasThirdParty(), data);
  }

  chatbotSubmitAdasReport(data) {
    return this.http.post<any>(this.apiUrl.chatbotSubmitAdasReport(), data, {
      headers: { Accept: 'application/json' }
    });
  }

  chatbotExtractAdasReport(jobId: string) {
    return this.http.get<any>(this.apiUrl.chatbotExtractAdasReport() + '?job_id=' + jobId, {
      headers: { Accept: 'application/json' }
    });
  }
}

